<!DOCTYPE html>
<html>
    <head>
        <base href="http://localhost:4201/">
    </head>
    <body>
        <app-header *ngIf="loggedIn()"></app-header>
        <router-outlet></router-outlet>
    </body>
</html>